<mat-dialog-content class="mat-typography">
 <div class="fx-column-center-space-around">
    <div class="mat-elevation-z8 table-container" id="detailsTable">
      <table mat-table class ="full-width-table" [dataSource]="detailsDataSource" matSort aria-label="Elements">
         <!-- Result Date Time Column -->
         <ng-container *ngFor="let disCol of displayedColumns; let colIndex = index" matColumnDef="{{disCol}}" >
          <th mat-header-cell *matHeaderCellDef>{{disCol}}</th>
          <td mat-cell *matCellDef="let row">{{row[displayedColumnValues[colIndex]]}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
  <br>
  <div  class="fx-row-stretch-space-around">
    <div *ngIf="imageSrc">
      <img [src]="imageSrc" class="image-src"  alt="sampleapplianceimage"/>
      <p>Picture 1</p>
    </div>
    <div *ngIf="imageSrc2">
      <img [src]="imageSrc2" class="image-src"  alt="sampleapplianceimage"/>
      <p>Picture 2</p>
    </div>
  </div>

</mat-dialog-content>
<mat-dialog-actions align="center">
 <div class="fx-row-center-center"><button mat-raised-button color="primary" (click)="close()">Close</button></div>
</mat-dialog-actions>